<template>
  <div v-if="aAdDoc.getInvitationsIsLoading() === true " data-cy="cyInvitationsLoading">
    {{ t('invitationIsLoadingText') }}
  </div>
  <div v-else  data-cy="cyInvitationsLoaded">
    <div class="subtitle">{{ t("itemInvitations") }}</div>
    {{ t("itemInvitationsEmpty") }}
  </div>
</template>

<script lang="ts">
import { useI18n } from "@/engineproject/default/common/i18n";

export default {
  props: {
    aAdDoc: {
      type: Object as () => Array<any>,
      required: true,
    },
  },
  setup(props: any, context: any) {
    const { t } = useI18n();

    return {
      t,
    };
  },
  components: { 
  },
};
</script>
